import React, {useState, useEffect , useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import templateService from "../../../services/template.service";
import Loading from "../../common/Loading";
import Swal from '../../helpers/swal';
import EmailEditor from '../../helpers/email-editor/EmailEditor';
const CreateAdminEmailTemplate = () => {
    const navigate = useNavigate();
    const [templateTypes, setTemplateTypes] = useState([]);
    const [existingEmailTemplates, setExistingEmailTemplates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingEcx, setLoadingEcx] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        reminderName: '',
        subject: '',
        content: '',
        usedBy: 'CLINIC'
    });
    const saveFnRef = useRef(null)
    const [savedData, setSavedData] = useState(null)
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setLoadingEcx(true);

                // Fetch both template types and existing Email templates in parallel
                const [templateTypesResponse, ecxTemplatesResponse] = await Promise.all([
                    templateService.getTemplateTypes(),
                    templateService.getEcxTemplate(0, 1000) // Fetch all templates
                ]);

                setTemplateTypes(templateTypesResponse.data);
                setExistingEmailTemplates(ecxTemplatesResponse.data.content);
            } catch (error) {
                console.error('Error fetching data:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to load template data. Please try again.',
                    confirmButtonColor: '#dc3545'
                });
            } finally {
                setLoading(false);
                setLoadingEcx(false);
            }
        };

        fetchData();
    }, []);

    const handleTemplateChange = (selectedReminderName) => {
        const selectedTemplate = templateTypes.find(template => template.reminderName === selectedReminderName);
        if (selectedTemplate) {
            setFormData({
                ...formData,
                reminderName: selectedReminderName,
                usedBy: selectedTemplate.usedBy
            });
        }
    };
        const handleEmailDesignSave = async () => {
            if (saveFnRef.current) {
            try {
                const { htmltemplate, template, thumbnail } = await saveFnRef.current()
                //console.log('HTML:', htmltemplate)
                //console.log('JSON:', template)
                //console.log('Thumbnail Blob:', thumbnail)

                setSavedData({ htmltemplate, template, thumbnail })
                 return { htmltemplate, template, thumbnail }
            } catch (err) {
                console.error('Save failed:', err)
            }
            }
        }
    const handleSubmit = async (e) => {
        handleEmailDesignSave();
        e.preventDefault();

        try {
            setSubmitting(true);
            // Get the latest email design
                const result = await handleEmailDesignSave()
                if (!result) throw new Error('Could not get email design')

                const { htmltemplate, template } = result
            // Find the selected template to get the reminderTypeId
            const selectedTemplate = templateTypes.find(t => t.reminderName === formData.reminderName);

            if (!selectedTemplate) {
                throw new Error('Selected template not found');
            }

            // Prepare the request body
            const requestBody = {
                reminderName: formData.reminderName,
                mediumType: "EMAIL",
                subjectLine: formData.subject,
                content: htmltemplate,          // set content = HTML
                jsonContent: template, // set json_content = JSON string
                usedBy: formData.usedBy,
                audioPath: null,
            };

            // Call the save API
            const response = await templateService.saveEcxTemplate(requestBody);

            // Show success message
            await Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Email template created successfully!',
                confirmButtonColor: '#0d6efd',
                timer: 2000,
                showConfirmButton: true
            });

            // Redirect to templates list
            navigate('/admin-templates');

        } catch (error) {
            console.error('Error creating Email template:', error);

            // Show error message
            await Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to create Email template. Please try again.',
                confirmButtonColor: '#dc3545'
            });
        } finally {
            setSubmitting(false);
        }
    };

    const handleCancel = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will lose all unsaved changes.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `<i class="bi bi-check"></i> Yes, cancel!`,
            cancelButtonText: `<i class="bi bi-x"></i> No Keep editing`,
            reverseButtons: true,
            customClass: {
                title: 'card-title',
                confirmButton: 'btn btn-danger me-2 btn-sm',
                cancelButton: 'btn btn-secondary me-2 btn-sm'
            },
            buttonsStyling: false
        }).then((result) => {
            if (result.isConfirmed) {
                navigate('/admin-templates');
            }
        });
    };

    // Filter templates that support Email and don't have existing Email templates
    const availableEmailTemplates = templateTypes.filter(template => {
        // Check if template supports Email
        if (!template.isEmail) return false;

        // Check if this template already has an Email template created
        const alreadyExists = existingEmailTemplates.some(existingTemplate =>
            existingTemplate.reminderTypeId === template.id &&
            existingTemplate.mediumType === 'EMAIL'
        );

        return !alreadyExists;
    });

    // Get already created Email templates for information display
    const createdEmailTemplates = templateTypes.filter(template => {
        return existingEmailTemplates.some(existingTemplate =>
            existingTemplate.reminderTypeId === template.id &&
            existingTemplate.mediumType === 'EMAIL'
        );
    });

    return (
        <div className="container container-xxl">
            <div className="pagetitle">
                <h1><i className="bi bi-envelope text-primary me-2"></i> Create Email Template</h1>
            </div>

            <div className="card card-padding">
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row mb-3 mt-3">
                            <div className="col-md-6">
                                <label className="form-label">Template Name *</label>
                                {loading || loadingEcx ? (
                                    <Loading/>
                                ) : (
                                    <>
                                        <select
                                            className="form-control"
                                            value={formData.reminderName}
                                            onChange={(e) => handleTemplateChange(e.target.value)}
                                            required
                                        >
                                            <option value="">Select a template type</option>
                                            {availableEmailTemplates.map(template => (
                                                <option key={template.id} value={template.reminderName}>
                                                    {template.reminderName}
                                                </option>
                                            ))}
                                        </select>
                                        {availableEmailTemplates.length === 0 && (
                                            <div className="alert alert-warning mt-2 mb-0">
                                                <i className="bi bi-exclamation-triangle me-2"></i>
                                                All available Email templates have already been created.
                                            </div>
                                        )}
                                    </>
                                )}
                                <div className="form-text">
                                    Select a template type that supports Email and hasn't been created yet
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Used By *</label>
                                <select
                                    className="form-control"
                                    value={formData.usedBy}
                                    onChange={(e) => setFormData({...formData, usedBy: e.target.value})}
                                    required
                                    disabled // Make it read-only since it's auto-set
                                >
                                    <option value="CLINIC">Clinic</option>
                                    <option value="ECX">ECX</option>
                                </select>
                                <div className="form-text">
                                    Automatically set based on template selection
                                </div>
                            </div>
                        </div>

                        {createdEmailTemplates.length > 0 && (
                            <div className="alert alert-info mb-3">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="bi bi-check-circle me-2"></i>
                                    <h6 className="mb-0">Already Created Email Templates</h6>
                                </div>
                                <div className="d-flex flex-wrap gap-2">
                                    {createdEmailTemplates.map(template => (
                                        <span key={template.id} className="badge bg-secondary">
                                            {template.reminderName}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {formData.reminderName && (
                            <div className="alert alert-info mb-3">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="bi bi-info-circle me-2 fs-5"></i>
                                    <h6 className="mb-0">Template Information</h6>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="template-info-item">
                                            <span className="fw-semibold text-dark">Name:</span>
                                            <span className="ms-1">{formData.reminderName}</span>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="template-info-item">
                                            <span className="fw-semibold text-dark">Category:</span>
                                            <span className="ms-1">
                                                {templateTypes.find(t => t.reminderName === formData.reminderName)?.rootCategory || 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="template-info-item">
                                            <span className="fw-semibold text-dark">Priority:</span>
                                            <span className="ms-1">
                                                {templateTypes.find(t => t.reminderName === formData.reminderName)?.priority || 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="template-info-item">
                                            <span className="fw-semibold text-dark">ID:</span>
                                            <span className="ms-1 small font-monospace">
                                                {templateTypes.find(t => t.reminderName === formData.reminderName)?.id || 'N/A'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="mb-3">
                            <label className="form-label">Email Subject *</label>
                            <input
                                type="text"
                                className="form-control"
                                value={formData.subject}
                                onChange={(e) => setFormData({...formData, subject: e.target.value})}
                                placeholder="Enter email subject line"
                                required
                            />
                        </div>

                        <div className="mb-3">
                            <EmailEditor  
                                emailSubject={formData.subject}
                                saveemail={(saveFn) => {
                                saveFnRef.current = saveFn
                                }}
                             />
                
                            {/*<label className="form-label">Email Content *</label>
                            <textarea
                                className="form-control"
                                rows="8"
                                value={formData.content}
                                onChange={(e) => setFormData({...formData, content: e.target.value})}
                                placeholder="Enter your email template content. Use variables like {PATIENT_NAME}, {CLINIC_NAME}, etc."
                                required
                            />
                            <div className="form-text">
                                Available variables: {"{PATIENT_NAME}, {CLINIC_NAME}, {APPOINTMENT_DATE}, {APPOINTMENT_TIME}"}
                            </div>*/}
                        </div>

                        <div className="d-flex gap-2 justify-content-end">
                            <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={handleCancel}
                                disabled={submitting}
                            >
                                <i className="bi bi-x"></i> Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-sm btn-primary"
                                disabled={!formData.reminderName || availableEmailTemplates.length === 0 || submitting}
                            >
                                {submitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Creating...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-floppy"></i> Create Email Template
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateAdminEmailTemplate;